/**
 * Entidade dona de uma fórmula efetiva (origem no grafo de dependências).
 * Espelha o TipoEntidadeFormulaEnum do MotorFiscal e do Suprimentos (mesmos valores).
 */
export enum TipoEntidadeFormulaEnum {
    PadraoSistema = 1,
    ModeloEmpresa = 2,
    NaturezaOperacao = 3,
    ExcecaoNaturezaOperacao = 4,
    RegraTributaria = 5,
    Difal = 6,
    ConfiguracaoCustoVenda = 7,
}
